import { Component, OnInit, ViewChild } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { GridComponent, PageSettingsModel, SelectionSettingsModel, ToolbarItems } from '@syncfusion/ej2-angular-grids';
import { ActivatedRoute, Router } from '@angular/router';
import { Location, DatePipe } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';

import { SharedFunctions } from '../../../../src/app/shared/shared.functions';

import { GridPageSettings, MenuFuncionCodes, EstadoConstants, SaveUsuarioDto, Usuario, Rol, TipoDocumento, SearchTipoDocumentoRequest, SavePersonVerificationImageRequestDto, SearchPersonaRequestDto, DialogConfirmResponse, DialogConfirmRequest, SearchConsorcioRequest, TenantFeatureFlags, PedidoComunidadRolDto, SearchComunidadRequest, UsuarioComunidadDto,
  SearchUsuarioHistorialRequestDto, SearchUsuarioHistorialItemDto, SearchRolRequest, Persona, ActivateUserRequestDto, BlockUserRequestDto, DialogTextoLibreRequest, DialogTextoLibreResponse, ChangeUserStateRequestDto, DialogPersonaSearchComponentRequestDto, DialogPersonaSearchComponentResponseDto, Tenant, SearchTenantRequest
 } from '../../../../src/app/shared/model';
import { UsuarioService, RolService, MenuFuncionService, TipoDocumentoService, PersonaService, TenantService, ConsorcioService, PedidoService, ComunidadService } from '../../../../src/app/shared/services';

import { DialogTextoLibreComponent } from '../../../../src/app/shared/components/modals/dialogTextoLibre.component';
import { DialogPersonaSearchComponent } from '../usuarios/components/dialogPersonaSearch.component';
import { DialogConfirmComponent } from '../../../../src/app/shared/components/modals/dialogConfirm.component';

@Component({
  selector: 'app-usuarioEdit',
  templateUrl: './usuarioEdit.component.html',
  styleUrls: ['./usuarioEdit.component.scss']
})

export class UsuarioEditComponent implements OnInit {

  @ViewChild('tenantRolesGrid')
  public tenantRolesGrid: GridComponent;
  @ViewChild('tenantComunidadPedidoRolGrid')
  public tenantComunidadPedidoRolGrid: GridComponent;

  usuarioFormGroup: FormGroup;
  personaFormGroup: FormGroup;

  hideClave: boolean = true;
  hideConfirmClave: boolean = true;
  claveChanged: boolean = false;
  confirmClaveChanged: boolean = false;
  mostrarColumnaConsorcios: boolean = false;

  usuarioId: number;

  public pageSettings: PageSettingsModel;
  public pageSizes: number[];
  public selectionOptions: SelectionSettingsModel;
  public toolbarOptions: ToolbarItems[];

  isValidating: boolean = false;
  isSearching: boolean = false;
  isHistorialSearching: boolean = false;
  isUserSaving: boolean = false;
  isPersonSaving: boolean = false;
  isActivating: boolean = false;
  isApproving: boolean = false;
  isRejecting: boolean = false;
  isBlocking: boolean = false;
  isResetting: boolean = false;
  isRolSearching: boolean = false;
  isImageLoading: boolean = false;
  isTipoDocumentoSearching: boolean = false;
  isPedidoComunidadRolSearching: boolean = false;
  isPersonaSearching: boolean = false;
  isTenantSearching: boolean = false;
  isPersonaDataSearching: boolean = false;

  canUserEdit: boolean = false;
  canUserActions: boolean = false;
  isNewUser: boolean = true;

  canDelete: boolean = false;
  canAdd: boolean = false;
  canView: boolean = false;
  canPersonAdd: boolean = false;
  canViewPersonDetail: boolean = false;
  canPersonEdit: boolean = false;
  showCuit: boolean = true;

  tenantFeatureFlags: TenantFeatureFlags[];

  bloqueado: boolean = false;
  activo: boolean = true;
  debeCambiarClave: boolean = false;
  msgError: string = "";
  usuario: Usuario;
  persona: Persona = new Persona(0, null, null, null, null, null, null, null, null,null, true, null, null, null);
  userImageBase64: string | ArrayBuffer | null;
  userImageExtension: string = "";
  rolList: Rol[];
  tenantList: Tenant[];
  tipoDocumentoList: TipoDocumento[];
  pedidoComunidadRolList: PedidoComunidadRolDto[];
  historialList: SearchUsuarioHistorialItemDto[];
  historialMsgError: string = "";
  personaMsgError: string = "";
  rolesString: string = "";
  tenantsString: string = "";
  personaSearchResult: Persona | null;

  tenantRolesList: any[];
  tenantComunidadPedidoRolList: any[];

  constructor(
    private formBuilder: FormBuilder,
    private location: Location,
    private router: Router,
    public dialog: MatDialog,
    private sharedFunctions: SharedFunctions,
    private route: ActivatedRoute,
    private datePipe: DatePipe,
    private tipoDocumentoService: TipoDocumentoService,
    private usuarioService: UsuarioService,
    private personaService: PersonaService,
    private menuService: MenuFuncionService,
    private tenantService: TenantService,
    private pedidoService: PedidoService,
    private comunidadService: ComunidadService,
    private consorcioService: ConsorcioService,
    private rolService: RolService) {
  }

  ngOnInit(): void {

    this.isValidating = true;
    this.menuService.checkMenuPadre(MenuFuncionCodes.USER).subscribe(data => {
      if (data != null && data.Success && data?.Result) {
        this.tenantService.getTenantFeatureFlagsByLoggedUserId().subscribe(dataTenant => {
          this.isValidating = false;
          if (data != null && data.Success) {
            this.tenantFeatureFlags = dataTenant.Result;

            this.canUserEdit = data.Result.some(x => x == MenuFuncionCodes.USER_EDIT);
            this.canAdd = data.Result.some(x => x == MenuFuncionCodes.USER_ADD);
            this.canView = data.Result.some(x => x == MenuFuncionCodes.USER_LIST);
            this.canUserActions = data.Result.some(x => x == MenuFuncionCodes.USER_ACTIONS);
            this.canDelete = data.Result.some(x => x == MenuFuncionCodes.USER_DELETE);

            this.loadView();
          }
        },
        (err: HttpErrorResponse) => {
          this.isSearching = false;
          this.sharedFunctions.handleError(err, true);
        })
      }
      else {
        this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
        this.onCancel();
      }
    },
    (err: HttpErrorResponse) => {
      this.isValidating = false;
      this.sharedFunctions.handleError(err, true);
    });
  }

  loadView() {
    this.pageSizes = GridPageSettings.PageSizeList;
    this.pageSettings = { pageCount: GridPageSettings.PageCount, pageSize: this.pageSizes[1], pageSizes: this.pageSizes };

    this.buildUserForm();
    this.getUserTenants();
    this.getPedidoComunidadRoles();

    this.loadEntity();

    this.menuService.checkMenuPadre(MenuFuncionCodes.PERSONA).subscribe(data => {
      if (data != null && data.Success && data?.Result) {
        this.isValidating = false;
        this.canPersonEdit = data.Result.some(x => x == MenuFuncionCodes.PERSONA_EDIT);
        this.canPersonAdd = data.Result.some(x => x == MenuFuncionCodes.PERSONA_ADD);
        this.canViewPersonDetail = data.Result != null && data.Result.length > 0;

        if (this.canPersonAdd || this.canPersonEdit) {
          this.buildPersonForm();
          this.getTiposDocumento();
          this.loadPersonData();
        }
      }
    },
    (err: HttpErrorResponse) => {
      this.sharedFunctions.handleError(err);
    });
  }

  buildUserForm() {
    this.usuarioFormGroup = this.formBuilder.group({
      'Mail': [null, [Validators.required, Validators.maxLength(255), Validators.email]],
      'ConfirmMail': [null, [Validators.required, Validators.maxLength(255), Validators.email]],
      'Movil': [null, Validators.maxLength(100)],
      'Login': [null, [Validators.required, Validators.maxLength(100)]],
      'Clave': [null, [Validators.required, Validators.maxLength(100)]],
      'ConfirmClave': [null, [Validators.required, Validators.maxLength(100)]],
      'MotivoBloqueo': [null, Validators.maxLength(300)],
      'Roles': [null],
      'Tenants': [null]
    });
  }

  buildPersonForm() {
    this.personaFormGroup = this.formBuilder.group({
      'Nombre': [null, [Validators.required, Validators.maxLength(150)]],
      'Apellido': [null, [Validators.required, Validators.maxLength(150)]],
      'TipoDocumentoId': [null],
      'NroDocumento': [null, Validators.maxLength(100)],
      'Cuit': [null, Validators.maxLength(100)],
      'FechaNacimiento': [null],
      'MailContacto': [null, [Validators.maxLength(255), Validators.email]],
      'MovilContacto': [null, Validators.maxLength(100)]
    });
  }

  getTiposDocumento() {
    var r = new SearchTipoDocumentoRequest(null, null, true, "Nombre", null, null, true);
    this.isTipoDocumentoSearching = true;

    this.tipoDocumentoService.search(r).subscribe(data => {
      this.isTipoDocumentoSearching = false;
      if (data != null) {
        this.tipoDocumentoList = data?.result;
      }
    },
    (err: HttpErrorResponse) => {
      this.isTipoDocumentoSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getPedidoComunidadRoles() {
    if (!this.tenantFeatureFlags?.some(f => f.HabilitarControlPedidos))
      return;

    this.isPedidoComunidadRolSearching = true;
    this.pedidoService.getPedidoComunidadRoles().subscribe(data => {
      this.isPedidoComunidadRolSearching = false;
      this.pedidoComunidadRolList = data?.Result;
    },
    (err: HttpErrorResponse) => {
      this.isPedidoComunidadRolSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getUserTenants() {
    var loggedUser = this.sharedFunctions.getLoggedUser();

    if (loggedUser != null && loggedUser.Id != null && loggedUser.Id > 0) {
      var r = new SearchTenantRequest(null, null, true, "Nombre", null, null, null, true);
      this.isTenantSearching = true;

      this.tenantService.search(r).subscribe(data => {
        this.isTenantSearching = false;
        this.tenantList = data?.result;

        this.agregarTenantRolRow(null);
        this.mostrarColumnaConsorcios = this.debeMostrarColumnaConsorcios();
      },
      (err: HttpErrorResponse) => {
        this.isTenantSearching = false;
        this.sharedFunctions.handleError(err);
      });
    }
  }

  compareTenants(o1: number, o2: number): boolean {
    return o1 == o2;
  }

  onTenantGridChange(fieldName: string | null, tenantId: number, value: any) {

    if (tenantId != null && tenantId > 0) {
      if (this.tenantRolesList == null)
        this.tenantRolesList = [];

      switch (fieldName) {
        case 'TenantId':
          var index = this.tenantRolesList?.findIndex(f => f.TenantId == tenantId);
          if (index < 0 && this.tenantRolesList.length <= (this.tenantList?.length ?? 0)) {
            this.tenantRolesList[this.tenantRolesList.length-1].TenantId = tenantId;
            this.tenantRolesList[this.tenantRolesList.length-1].TenantNombre = this.tenantList.find(f => f.Id == tenantId)?.Nombre;

            this.agregarTenantRolRow(null);

            this.getRolesByTenant(tenantId);
            this.getConsorciosByTenant(tenantId);
            this.getComunidadesByTenant(tenantId, null);
          }

          this.tenantRolesGrid?.refresh();
          break;

        case 'RolId':
          var index = this.tenantRolesList?.findIndex(f => f.TenantId == tenantId);
          if (index >= 0)
            this.tenantRolesList[index].RolId = value;
          this.tenantRolesGrid?.refresh();
          break;

        case 'ConsorcioId':
          var index = this.tenantRolesList?.findIndex(f => f.TenantId == tenantId);
          if (index >= 0) {
            this.tenantRolesList[index].ConsorcioId = value;
            this.getComunidadesByTenant(this.tenantRolesList[index].TenantId, this.tenantRolesList[index].ConsorcioId);
          }
          this.tenantRolesGrid?.refresh();
          break;

        case 'ComunidadId':
          var index = this.tenantRolesList?.findIndex(f => f.TenantId == tenantId);
          if (index >= 0) {
            this.tenantRolesList[index].ComunidadId = value;

            // console.log("111",this.tenantComunidadPedidoRolList);
            // console.log(this.tenantRolesList[index]);
            if (this.tenantFeatureFlags.some(f => f.TenantId == tenantId && f.HabilitarControlPedidos)) {
              if (this.tenantComunidadPedidoRolList == null)
                this.tenantComunidadPedidoRolList = [];

              if (value != null && value.length > 0) {
                for (var i=0; i<value.length; i++) {
                  var index2 = this.tenantComunidadPedidoRolList?.findIndex(f => f.TenantId == tenantId && f.ComunidadId == value[i]);
                  // console.log("index2: "+index2 + " - tenant id: " + tenantId + " - comunidad id: " + value[i] + " - "+this.tenantRolesList[index].Comunidades?.filter(f => f.Id == value[i])[0].Nombre);
                  if (index2 == null || index2 < 0) {
                    this.tenantComunidadPedidoRolList.push({
                      TenantId: this.tenantRolesList[index].TenantId,
                      TenantNombre: this.tenantRolesList[index].TenantNombre,
                      ComunidadId: value[i],
                      ComunidadNombre: this.tenantRolesList[index].Comunidades?.filter(f => f.Id == value[i])[0].Nombre,
                      PedidoComunidadRol: null,
                      PedidoComunidadRolNombre: null
                    });
                  }
                }
              }

              if (this.tenantComunidadPedidoRolList != null && this.tenantComunidadPedidoRolList.length > 0) {
                var indexForDeleting : number[] = [];
                var localTenantComunidadPedidoRolList = this.tenantComunidadPedidoRolList.filter(f => f.TenantId == tenantId);
                if (localTenantComunidadPedidoRolList != null && localTenantComunidadPedidoRolList.length > 0) {
                  for (var i=0; i<localTenantComunidadPedidoRolList.length; i++) {
                    var index3 = value?.findIndex(f => localTenantComunidadPedidoRolList[i].ComunidadId == f);
                    // console.log("index3: "+index3 + " - tenant id: " + tenantId +
                    //   " - comunidad id: " + this.tenantComunidadPedidoRolList[i].ComunidadId);
                    if (index3 == null || index3 < 0)
                      indexForDeleting.push(i);
                  }

                  //Se ordena al reves para arrancar a eliminar items desde el mas lejano al mas cercano
                  indexForDeleting = indexForDeleting.sort((a, b) => b - a);
                  for (var i=0; i<indexForDeleting.length; i++)
                    this.tenantComunidadPedidoRolList.splice(i, 1);
                }
              }
            }
            // console.log("222",this.tenantComunidadPedidoRolList);
          }

          this.tenantRolesGrid?.refresh();
          if (this.tenantComunidadPedidoRolGrid != null)
            this.tenantComunidadPedidoRolGrid?.refresh();
          break;

        case 'PedidoComunidadRol':
          var index = this.tenantRolesList?.findIndex(f => f.TenantId == tenantId);
          if (index >= 0)
            this.tenantRolesList[index].PedidoComunidadRol = value;
          this.tenantComunidadPedidoRolGrid?.refresh();
          break;
      }
    }
  }

  onTenantComunidadPedidoRolGridChange(fieldName: string | null, comunidadId: number, value: any) {

    if (comunidadId != null && comunidadId > 0) {
      if (this.tenantComunidadPedidoRolList == null)
        this.tenantComunidadPedidoRolList = [];

      switch (fieldName) {
        case 'PedidoComunidadRol':
          var index = this.tenantComunidadPedidoRolList?.findIndex(f => f.ComunidadId == comunidadId);
          if (index >= 0)
            this.tenantComunidadPedidoRolList[index].PedidoComunidadRol = value;
          break;
      }

      this.tenantComunidadPedidoRolGrid?.refresh();
    }
  }

  getRolesByTenant(tenantId: number | null) {
    if (tenantId != null && tenantId > 0) {
      var index = this.tenantRolesList?.findIndex(f => f.TenantId == tenantId);
      if (index >= 0) {
        var r = new SearchRolRequest(null, null, true, "Nombre", null, null, tenantId, true);
        this.tenantRolesList[index].IsRolSearching = true;

        this.rolService.search(r).subscribe(data => {
          this.tenantRolesList[index].IsRolSearching = false;
          this.tenantRolesList[index].Roles = data?.result;

          this.tenantRolesGrid?.refresh();
        },
        (err: HttpErrorResponse) => {
          this.tenantRolesList[index].IsRolSearching = false;
          this.sharedFunctions.handleError(err, true);
        });
      }
    }
  }

  getConsorciosByTenant(tenantId: number) {
    if (!this.tenantFeatureFlags.some(f => f.TenantId == tenantId && f.HabilitarGestionConsorcio))
      return false;

    if (tenantId != null && tenantId > 0) {
      var index = this.tenantRolesList?.findIndex(f => f.TenantId == tenantId);
      if (index >= 0) {
        var r = new SearchConsorcioRequest(null, null, true, "Nombre", null, null, null, null, tenantId, true);
        this.tenantRolesList[index].IsConsorcioSearching = true;

        this.consorcioService.search(r).subscribe(data => {
          this.tenantRolesList[index].IsConsorcioSearching = false;
          this.tenantRolesList[index].Consorcios = data?.result;

          this.tenantRolesGrid?.refresh();
        },
        (err: HttpErrorResponse) => {
          this.tenantRolesList[index].IsConsorcioSearching = false;
          this.sharedFunctions.handleError(err, true);
        });
      }
    }
  }

  getComunidadesByTenant(tenantId: number, consorcioId: number | null) {
    if (tenantId != null && tenantId > 0) {
      var index = this.tenantRolesList?.findIndex(f => f.TenantId == tenantId);
      if (index >= 0) {
        var r = new SearchComunidadRequest(null, null, true, "Nombre", null, consorcioId, null, null, tenantId, true);
        this.tenantRolesList[index].IsComunidadSearching = true;

        this.comunidadService.search(r).subscribe(data => {
          this.tenantRolesList[index].IsComunidadSearching = false;
          this.tenantRolesList[index].Comunidades = data?.result;

          this.tenantRolesGrid?.refresh();
        },
        (err: HttpErrorResponse) => {
          this.tenantRolesList[index].IsComunidadSearching = false;
          this.sharedFunctions.handleError(err, true);
        });
      }
    }
  }

  compareRoles(o1: number, o2: number): boolean {
    return o1 == o2;
  }

  compareConsorcios(o1: number, o2: number): boolean {
    return o1 == o2;
  }

  compareComunidades(o1: number, o2: number): boolean {
    return o1 == o2;
  }

  convertFileToBase64(event, fieldName) {
    this.userImageBase64 = null;
    const file = event.target.files[0];

    if (file != null) {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        // this.backofficeImageBase64 = reader.result;
      };
      reader.onloadend = () => {

        var imageBase64 = reader.result;
        var imageExtension = (file?.name?.split('.')?.pop() ?? "");

        switch (fieldName) {
          case "ImagenPerfil":
            this.userImageBase64 = imageBase64;
            this.userImageExtension = imageExtension;
            break;
          case "DniFrente":
          case "DniDorso":
          case "Selfie":
            this.cargarImagenVerificacion(fieldName, imageBase64, imageExtension);
            break;
        }
        // console.log(reader.result);
      };
    }
  }

  isProcessing() {
    return (this.isSearching || this.isUserSaving || this.isPersonSaving || this.isActivating || this.isApproving || this.isRejecting || this.isBlocking);
  }

  showStateFlowButtons() {
    return (this.usuario != null && this.usuario.Id != null && this.usuario.Id > 0 && this.usuario.UsuarioEstadoId == EstadoConstants.ESTADO_USUARIO_PENDIENTE && this.canUserEdit);
  }

  showActionButtons() {
    return (this.usuario != null && this.usuario.Id != null && this.usuario.Id > 0 && this.usuario.UsuarioEstadoId == EstadoConstants.ESTADO_USUARIO_APROBADO && this.canUserActions);
  }

  debeMostrarColumnaConsorcios() {
    // if (this.tenantRolesList != null && this.tenantRolesList.length > 0)
    //   return this.tenantRolesList.some(f => this.tenantFeatureFlags?.some(ff => ff.TenantId == f.TenantId && ff.HabilitarGestionConsorcio));
    // this.tenantRolesGrid.refreshColumns();

    // return false;
    return (this.tenantFeatureFlags?.some(ff => ff.HabilitarGestionConsorcio));
  }

  mostrarColumnaConsorciosByTenant(tenantId: number) {
    return this.tenantFeatureFlags?.some(ff => ff.TenantId == tenantId && ff.HabilitarGestionConsorcio);
  }

  mostrarConfigPedidos() {
    if (this.tenantRolesList != null && this.tenantRolesList.length > 0)
      return this.tenantRolesList.some(f => this.tenantFeatureFlags?.some(ff => ff.TenantId == f.TenantId && ff.HabilitarControlPedidos));

    return false;
  }

  loadEntity() {
    this.route.params.subscribe(params => {
      if (params['id'] != null && params['id'] != '0') {
        this.usuarioId = Number(params['id']);

        if (this.usuarioId > 0) {
          if (this.canView || this.canUserEdit) {
            this.isNewUser = false;
            this.isSearching = true;
            this.usuarioService.get(this.usuarioId).subscribe(data => {
              this.isSearching = false;
              if (data != null && data.Success) {
                this.usuario = data.Result;

                if (this.usuario != null && this.usuario.Id != null && this.usuario.Id > 0) {
                  if (this.canUserEdit) {
                    this.usuarioFormGroup.patchValue(this.usuario);

                    //Se ponen valores para que no falle el usuarioForm por sus validaciones pero no se usan para editar
                    this.usuarioFormGroup.get('Clave')?.setValue("123");
                    this.usuarioFormGroup.get('ConfirmClave')?.setValue("123");
                    this.usuarioFormGroup.get('ConfirmMail')?.setValue(this.usuario.Mail);
                  }

                  this.getPersona();
                  this.getHistorial();

                  setTimeout(() => {
                    this.tenantRolesList = [];

                    if (this.usuario.Tenants != null) {
                      // this.usuarioFormGroup.get('Tenants')?.setValue(this.usuario.Tenants?.map(item => item?.Id));
                      for (var i=0; i<this.usuario.Tenants.length; i++) {
                        this.tenantRolesList.push({
                          TenantId: this.usuario.Tenants[i].Id,
                          TenantNombre: this.usuario.Tenants[i].NombreCorto,
                          RolId: [],
                          RolNombre: "",
                          Roles: null,
                          IsRolSearching: false,
                          ConsorcioId: [],
                          ConsorcioNombre: "",
                          Consorcios: null,
                          IsConsorcioSearching: false,
                          ComunidadId: [],
                          ComunidadNombre: "",
                          Comunidades: null,
                          IsComunidadSearching: false
                        });
                        this.getRolesByTenant(this.usuario.Tenants[i].Id);
                        this.getConsorciosByTenant(this.usuario.Tenants[i].Id);
                        this.getComunidadesByTenant(this.usuario.Tenants[i].Id, null);
                      }
                    }

                    if (this.usuario.Roles != null) {
                      // this.usuarioFormGroup.get('Roles')?.setValue(this.usuario.Roles?.map(item => item?.Id));

                      for (var i=0; i<this.usuario.Roles.length; i++) {
                        var index = this.tenantRolesList?.findIndex(f => f.TenantId == this.usuario.Roles[i].TenantId);
                        if (index >= 0) {
                          this.tenantRolesList[index].RolId.push(this.usuario.Roles[i].Id);
                          this.tenantRolesList[index].RolNombre += this.usuario.Roles[i].Nombre + ", ";
                        }
                      }

                      var sinTenantList = this.usuario.Roles.filter(f => f.TenantId == null || f.TenantId == 0);
                      if (sinTenantList != null && sinTenantList.length > 0) {
                        for (var i=0; i<this.tenantRolesList.length; i++) {
                          for (var j=0; j<sinTenantList.length; j++) {
                            if (this.tenantRolesList[i].RolId == null)
                              this.tenantRolesList[i].RolId = [];
                            this.tenantRolesList[i].RolId.push(sinTenantList[j].Id);

                            if (this.tenantRolesList[i].RolId == null || this.tenantRolesList[i].RolId.length == 0)
                              this.getRolesByTenant(null);
                          }
                          this.tenantRolesList[i].RolNombre += sinTenantList.map(f => f.Nombre)?.join(", ");
                        }
                      }

                      for (var i=0; i<this.tenantRolesList.length; i++) {
                        if (this.tenantRolesList[i].RolNombre?.toString().substr(this.tenantRolesList[i].RolNombre.length - 2, 2) == ", ")
                          this.tenantRolesList[i].RolNombre = this.tenantRolesList[i].RolNombre?.toString().substr(0, this.tenantRolesList[i].RolNombre.length - 2);
                      }
                    }

                    if (this.usuario.Consorcios != null) {
                      // this.usuarioFormGroup.get('Consorcios')?.setValue(this.usuario.Consorcios?.map(item => item?.Id));
                      let index = -1;
                      for (var i=0; i<this.usuario.Consorcios.length; i++) {
                        index = this.tenantRolesList?.findIndex(f => f.TenantId == this.usuario.Consorcios[i].TenantId);
                        if (index >= 0) {
                          this.tenantRolesList[index].ConsorcioId.push(this.usuario.Consorcios[i].Id);
                          this.tenantRolesList[index].ConsorcioNombre += this.usuario.Consorcios[i].Nombre + ", ";
                        }
                      }

                      if (index >= 0 && this.tenantRolesList[index].ConsorcioNombre != null && this.tenantRolesList[index].ConsorcioNombre.length > 0)
                        this.tenantRolesList[index].ConsorcioNombre = this.tenantRolesList[index].ConsorcioNombre.substring(0, this.tenantRolesList[index].ConsorcioNombre.length - 2);
                    }

                    if (this.usuario.Comunidades != null) {
                      this.tenantComunidadPedidoRolList = [];
                      // this.usuarioFormGroup.get('Comunidades')?.setValue(this.usuario.Comunidades?.map(item => item?.Id));
                      let index = -1;
                      for (var i=0; i<this.usuario.Comunidades.length; i++) {
                        index = this.tenantRolesList?.findIndex(f => f.TenantId == this.usuario.Comunidades[i].TenantId);
                        if (index >= 0) {
                          this.tenantRolesList[index].ComunidadId.push(this.usuario.Comunidades[i].ComunidadId);
                          this.tenantRolesList[index].ComunidadNombre += this.usuario.Comunidades[i].Comunidad + ", ";

                          if (this.tenantFeatureFlags.some(f => f.TenantId == this.tenantRolesList[index].TenantId && f.HabilitarControlPedidos)) {
                            this.tenantComunidadPedidoRolList.push({
                              TenantId: this.tenantRolesList[index].TenantId,
                              TenantNombre: this.tenantRolesList[index].TenantNombre,
                              ComunidadId: this.usuario.Comunidades[i].ComunidadId,
                              ComunidadNombre: this.usuario.Comunidades[i].Comunidad,
                              PedidoComunidadRol: this.usuario.Comunidades[i].PedidoComunidadRol,
                              PedidoComunidadRolNombre: this.usuario.Comunidades[i].PedidoComunidadRolNombre
                            });
                          }
                        }
                      }

                      if (index >= 0 && this.tenantRolesList[index].ComunidadNombre != null && this.tenantRolesList[index].ComunidadNombre.length > 0)
                        this.tenantRolesList[index].ComunidadNombre = this.tenantRolesList[index].ComunidadNombre.substring(0, this.tenantRolesList[index].ComunidadNombre.length - 2);
                    }

                    this.agregarTenantRolRow(null);
                  }, 1000);
                }
                else
                  this.msgError = "No se encontró el usuario seleccionado.";
              }
              else
                this.msgError = "Ocurrió un error al intentar obtener los datos del usuario.";
            },
            (err: HttpErrorResponse) => {
              this.isSearching = false;
              this.sharedFunctions.handleError(err, true);
            })
          }
          else {
            this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
            this.onCancel();
          }
        }
        else
          this.msgError = "Item no válido.";
      }
      else {
        if (this.canAdd) {
          this.usuario = Usuario.getNewInstance();
          this.usuarioFormGroup.patchValue(this.usuario);

          this.agregarTenantRolRow(null);

          this.persona = new Persona(0, null, null, null, null, null, null, null, null, null,true, null, null, null);
          if (this.canPersonAdd || this.canPersonEdit)
            this.personaFormGroup.patchValue(this.persona);
        }
        else {
          this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
          this.onCancel();
        }
      }
    });
  }

  getPersona() {
    if (this.usuario != null && this.usuario.PersonaId != null && this.usuario.PersonaId > 0) {
      this.isPersonaSearching = true;
      this.personaMsgError = "";

      this.personaService.get(this.usuario.PersonaId).subscribe(data => {
        this.isPersonaSearching = false;
        if (data != null) {
          this.persona = data.Result;
          this.loadPersonData();
        }
        else
          this.personaMsgError = "Ocurrió un error al intentar obtener los datos de la persona.";
      },
        (err: HttpErrorResponse) => {
          this.isPersonaSearching = false;
          this.sharedFunctions.handleError(err);
        })
    }
  }

  loadPersonData() {
    if (this.persona != null) {
      if (this.canPersonEdit) {
        this.personaFormGroup.patchValue(this.persona);

        if (this.persona.FechaNacimiento != null)
          this.personaFormGroup?.get("FechaNacimiento")?.setValue(this.datePipe.transform(this.persona.FechaNacimiento, "yyyy-MM-dd"));

        this.onTipoDocumentoSelection();
      }
    }
  }

  getHistorial() {
    if (this.usuario != null && this.usuario.Id != null && this.usuario.Id > 0) {
      var r = new SearchUsuarioHistorialRequestDto(null, null, false, "FechaCreacion", null, null, this.usuario.Id, '');
      this.isHistorialSearching = true;
      this.historialMsgError = "";

      this.usuarioService.searchHistory(r).subscribe(data => {
        this.isHistorialSearching = false;
        if (data != null) {
          this.historialList = data.result;
        }
        else
          this.historialMsgError = "Ocurrió un error al intentar obtener los datos del usuario.";
      },
      (err: HttpErrorResponse) => {
        this.isHistorialSearching = false;
        this.sharedFunctions.handleError(err);
      })
    }
  }

  onPersonSearchClick() {
    if (this.isProcessing())
        return;

    const dialogRef = this.dialog.open(DialogPersonaSearchComponent, {
        width: '90%',
        data: new DialogPersonaSearchComponentRequestDto(false, 0)
    });

    dialogRef.afterClosed().subscribe((result: DialogPersonaSearchComponentResponseDto) => {
      if (result != null && !result.Cancelled) {
        var u = (result.Items != null && result.Items.length > 0 ? result.Items[0] : null);

        this.persona = new Persona(0, null, null, null, null, null, null,null, null, null, true, null, null, null);
        if (u != null && u.Id != null && u.Id > 0)
          this.persona = new Persona(u.Id, u.Nombre, u.Apellido, u.NroDocumento,u.TipoDocumentoNombre, u.TipoDocumentoId, u.FechaNacimiento, u.Cuit, u.MailContacto, u.MovilContacto,
            u.Activo, u.FotoDniFrenteUrl, u.FotoDniDorsoUrl, u.FotoSelfieUrl);

        this.loadPersonData();
      }
    });
  }

  onPersonDeassociateClick() {
    this.persona = new Persona(0, null, null, null, null, null, null, null, null,null, true, null, null, null);
    if (this.usuario != null)
      this.usuario.PersonaId = 0;
    this.loadPersonData();
  }

  canDeassociatePerson() {
    return this.canUserEdit && this.canPersonAdd && this.persona != null && this.persona.Id != null && this.persona.Id > 0;
  }

  clearDate(formFieldName: string) {
    if (formFieldName != null && formFieldName.length > 0) {
      if (this.personaFormGroup?.get(formFieldName) != null && this.personaFormGroup?.get(formFieldName)?.value)
        this.personaFormGroup?.get(formFieldName)?.setValue(null);
    }
  }

  getErrorNombre() {
    var v = this.personaFormGroup?.get('Nombre');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 150 caracteres alcanzado';
    return '';
  }

  getErrorApellido() {
    var v = this.personaFormGroup?.get('Apellido');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 150 caracteres alcanzado';
    return '';
  }

  getErrorFechaNacimiento() {
    return this.personaFormGroup?.get('FechaNacimiento')?.hasError('required') ? 'El campo es obligatorio' : '';
  }

  getErrorTipoDocumentoId() {
    return this.personaFormGroup?.get('TipoDocumentoId')?.hasError('required') ? 'El campo es obligatorio' : '';
  }

  getErrorNroDocumento() {
    var v = this.personaFormGroup?.get('NroDocumento');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 100 caracteres alcanzado';
    return '';
  }

  getErrorCuit() {
    var v = this.personaFormGroup?.get('Cuit');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 100 caracteres alcanzado';
    return '';
  }

  getErrorMailContacto() {
    var v = this.personaFormGroup?.get('MailContacto');
    if (v?.hasError('maxlength'))
      return 'Límite de 255 caracteres alcanzado';
    if (v?.hasError('email'))
      return 'Debe ingresar un email con formato válido';
    return '';
  }

  getErrorMovilContacto() {
    var v = this.personaFormGroup?.get('MovilContacto');
    if (v?.hasError('maxlength'))
      return 'Límite de 100 caracteres alcanzado';
    if(v?.hasError('required'))
      return 'El campo es obligatorio';
    return '';
  }

  getErrorLogin() {
    var v = this.usuarioFormGroup.get('Login');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 100 caracteres alcanzado';
    return '';
  }

  getErrorClave() {
    var v = this.usuarioFormGroup.get('Clave');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 100 caracteres alcanzado';
    return '';
  }

  getErrorConfirmClave() {
    var v = this.usuarioFormGroup.get('ConfirmClave');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 255 caracteres alcanzado';
    if (v?.hasError('email'))
      return 'Debe ingresar un email con formato válido';
    return '';
  }

  getErrorMovil() {
    var v = this.usuarioFormGroup.get('Movil');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 100 caracteres alcanzado';
    return '';
  }

  getErrorMail() {
    var v = this.usuarioFormGroup.get('Mail');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 255 caracteres alcanzado';
    if (v?.hasError('email'))
      return 'Debe ingresar un email con formato válido';
    return '';
  }

  getErrorConfirmMail() {
    var v = this.usuarioFormGroup.get('ConfirmMail');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 255 caracteres alcanzado';
    if (v?.hasError('email'))
      return 'Debe ingresar un email con formato válido';
    return '';
  }

  getErrorRoles() {
    return this.usuarioFormGroup.get('Roles')?.hasError('required') ? 'El campo es obligatorio' : '';
  }

  hasPersonaFotoDniFrente() {
    return (this.persona?.FotoDniFrenteUrl != null && this.persona?.FotoDniFrenteUrl.length > 0);
  }

  hasPersonaFotoDniDorso() {
    return (this.persona?.FotoDniDorsoUrl != null && this.persona?.FotoDniDorsoUrl.length > 0);
  }

  hasPersonaFotoSelfie() {
    return (this.persona?.FotoSelfieUrl != null && this.persona?.FotoSelfieUrl.length > 0);
  }

  userImageChanged() {
    return (this.userImageBase64 != null);
  }

  onGuardarUsuario() {

    //Si selecciono como tipo de doc CUIT o CIUL, le asigno el valor del campo Nro. Doc. a CUIT
    if (!this.showCuit) {
      this.personaFormGroup?.get("Cuit")?.setValue(this.personaFormGroup?.get("NroDocumento")?.value);
    }

    if (!this.usuarioFormGroup.valid) {
      this.sharedFunctions.showMessage("Por favor complete todos los datos obligatorios para continuar", "Error");
      return false;
    }

    if (this.usuarioFormGroup.get('Mail')?.value?.toString() != this.usuarioFormGroup.get('ConfirmMail')?.value?.toString()) {
      this.sharedFunctions.showMessage("Revise el mail escrito y su confirmación ya que son diferentes", "Error");
      return false;
    }

    if (this.isNewUser) {
      if (this.usuarioFormGroup.get('Clave')?.value?.toString() != this.usuarioFormGroup.get('ConfirmClave')?.value?.toString()) {
        this.sharedFunctions.showMessage("Revise la clave seteada y su confirmación ya que son diferentes", "Error");
        return false;
      }

      if (!this.personaFormGroup.valid) {
        this.sharedFunctions.showMessage("Por favor complete todos los datos obligatorios de la persona para continuar", "Error");
        return false;
      }
    }

    // var m = this.usuarioFormGroup.get('Movil')?.value;
    // if (m != null && m.length > 0 && !m.startsWith("+"))
    //   this.usuarioFormGroup.get('Movil')?.setValue("+" + m);

    var index = this.userImageBase64?.toString()?.indexOf(",");
    var r = new SaveUsuarioDto(0, null, null, null, null, null, null, null, null, null, null, null, null, null, false, false, true, [], [], []);

    var roles : number[] = [];
    if (this.tenantRolesList != null) {
      for (var i=0; i<this.tenantRolesList.length; i++) {
        if (this.tenantRolesList[i].RolId != null) {
          for (var j=0; j<this.tenantRolesList[i].RolId.length; j++) {
            if (this.tenantRolesList[i].RolId[j] != null && this.tenantRolesList[i].RolId[j] > 0)
              roles.push(this.tenantRolesList[i].RolId[j]);
          }
        }
      }
    }

    var consorcios : number[] = [];
    if (this.tenantRolesList != null) {
      for (var i=0; i<this.tenantRolesList.length; i++) {
        if (this.tenantRolesList[i].ConsorcioId != null) {
          for (var j=0; j<this.tenantRolesList[i].ConsorcioId.length; j++) {
            if (this.tenantRolesList[i].ConsorcioId[j] != null && this.tenantRolesList[i].ConsorcioId[j] > 0)
              consorcios.push(this.tenantRolesList[i].ConsorcioId[j]);
          }
        }
      }
    }

    var comunidades : UsuarioComunidadDto[] = [];
    if (this.tenantRolesList != null) {
      for (var i=0; i<this.tenantRolesList.length; i++) {
        if (this.tenantRolesList[i].ComunidadId != null) {
          for (var j=0; j<this.tenantRolesList[i].ComunidadId.length; j++) {
            if (this.tenantRolesList[i].ComunidadId[j] != null && this.tenantRolesList[i].ComunidadId[j] > 0) {
              var pedidoRolList = this.tenantComunidadPedidoRolList?.filter(f => f.ComunidadId == this.tenantRolesList[i].ComunidadId[j]);
              var pedidoRol = (pedidoRolList != null && pedidoRolList.length > 0 ? pedidoRolList[0] : null);

              comunidades.push(new UsuarioComunidadDto(0, this.usuario?.Id ?? 0, this.usuario?.Login,
                                this.tenantRolesList[i].ComunidadId[j], "", pedidoRol?.PedidoComunidadRol,
                                pedidoRol?.PedidoComunidadRolNombre, this.tenantRolesList[i].TenantId));
            }
          }
        }
      }
    }

    r =
    {
      ...this.usuarioFormGroup.value,
      ...this.personaFormGroup.value,
      ...
      {
        Id: (this.usuario?.Id ?? 0),
        PersonaId: (this.persona?.Id ?? 0),
        FotoPerfilBase64: (index != null && index >= 0 ? this.userImageBase64?.toString()?.substring(index + 1) : null),
        FotoPerfilExtension: this.userImageExtension,
        DebeCambiarClave: this.debeCambiarClave,
        Bloqueado: this.bloqueado,
        Activo: this.activo,
        Roles: roles,
        Tenants: this.tenantRolesList?.filter(f => f.TenantId != null && f.TenantId > 0)?.map(s => s.TenantId),
        Consorcios: consorcios,
        Comunidades: comunidades
      },
    };

    this.isUserSaving = true;
    this.usuarioService.save(r).subscribe(data => {
      this.isUserSaving = false;
      if (data != null && data.Success && data.Result != null && data.Result.Id != null && data.Result.Id > 0) {
        this.getHistorial();
        this.sharedFunctions.showMessage("Se guardaron correctamente los datos!", "Operación Exitosa!");

        if (this.isNewUser)
          this.onCancel();
      }
      else
        this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error ejecutando la operación", "Error");
    },
    (err: HttpErrorResponse) => {
      this.isUserSaving = false;
      this.sharedFunctions.handleError(err, true);
    })
  }

  onActivar() {
    if (this.isProcessing()) return false;

    const dialogRef = this.dialog.open(DialogTextoLibreComponent, {
      width: '500px',
      data: new DialogTextoLibreRequest(
        (this.usuario?.Activo ? 'Desactivación de Usuario' : 'Activación de Usuario'),
        'Ingrese un comentario (opcional)',
        'Aceptar',
        'Cancelar Operación',
        300
      )
    });

    dialogRef.afterClosed().subscribe((result: DialogTextoLibreResponse) => {
      if (result != null && !result.Cancelled && this.usuario?.Id != null && result.Result != null) {
        var r = new ActivateUserRequestDto(this.usuario?.Id, !this.usuario?.Activo, result.Result);

        this.isActivating = true;
        this.usuarioService.activateUser(r).subscribe(data => {
          this.isActivating = false;
          if (data != null && data.Success && data.Result != null && data.Result) {
            this.sharedFunctions.showMessage("Se guardaron correctamente los datos!", "Operación Exitosa!");
            this.loadView();
          }
          else
            this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error ejecutando la operación", "Error");
        },
          (err: HttpErrorResponse) => {
            this.isActivating = false;
            this.sharedFunctions.handleError(err, true);
          })
      }
    });
  }

  onAprobar() {
    if (this.isProcessing()) return false;

    const dialogRef = this.dialog.open(DialogTextoLibreComponent, {
      width: '500px',
      data: new DialogTextoLibreRequest(
        'Aprobación de Usuario',
        'Ingrese un comentario (opcional)',
        'Aprobar',
        'Cancelar Operación',
        300
      )
    });

    dialogRef.afterClosed().subscribe((result: DialogTextoLibreResponse) => {
      if (result != null && !result.Cancelled && this.usuario?.Id != null && result.Result) {

        var r = new ChangeUserStateRequestDto(this.usuario?.Id, 0, result.Result);
        this.isApproving = true;

        this.usuarioService.approveUser(r).subscribe(data => {
          this.isApproving = false;
          if (data != null && data.Success && data.Result != null && data.Result) {
            this.sharedFunctions.showMessage("Se guardaron correctamente los datos!", "Operación Exitosa!");
            this.loadView();
          }
          else
            this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error ejecutando la operación", "Error");
        },
          (err: HttpErrorResponse) => {
            this.isApproving = false;
            this.sharedFunctions.handleError(err, true);
          })
      }
    });
  }

  onRechazar() {
    if (this.isProcessing()) return false;

    const dialogRef = this.dialog.open(DialogTextoLibreComponent, {
      width: '500px',
      data: new DialogTextoLibreRequest(
        'Rechazo de Usuario',
        'Ingrese el motivo del rechazo del usuario',
        'Rechazar',
        'Cancelar Operación',
        300
      )
    });

    dialogRef.afterClosed().subscribe((result: DialogTextoLibreResponse) => {
      if (result != null && !result.Cancelled && this.usuario?.Id != null) {
        if (result.Result == null || result.Result.length == 0) {
          this.sharedFunctions.showMessage("Debe ingresar un motivo de rechazo para continuar", "Error");
          return false;
        }

        var r = new ChangeUserStateRequestDto(this.usuario?.Id, 0, result.Result);
        this.isRejecting = true;

        this.usuarioService.rejectUser(r).subscribe(data => {
          this.isRejecting = false;
          if (data != null && data.Success && data.Result != null && data.Result) {
            this.sharedFunctions.showMessage("Se guardaron correctamente los datos!", "Operación Exitosa!");
            this.loadView();
          }
          else
            this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error ejecutando la operación", "Error");
        },
          (err: HttpErrorResponse) => {
            this.isRejecting = false;
            this.sharedFunctions.handleError(err, true);
          })
      }
    });
  }

  onBloquear() {
    if (this.isProcessing()) return false;

    const dialogRef = this.dialog.open(DialogTextoLibreComponent, {
      width: '500px',
      data: new DialogTextoLibreRequest(
        (this.usuario?.Bloqueado ? 'Desbloqueo de Usuario' : 'Bloqueo de Usuario'),
        'Ingrese un comentario (opcional)',
        'Aceptar',
        'Cancelar Operación',
        300
      )
    });

    dialogRef.afterClosed().subscribe((result: DialogTextoLibreResponse) => {
      if (result != null && !result.Cancelled && this.usuario?.Id != null && result.Result != null) {
        var r = new BlockUserRequestDto(this.usuario?.Id, !this.usuario?.Bloqueado, result.Result);

        this.isBlocking = true;
        this.usuarioService.blockUser(r).subscribe(data => {
          this.isBlocking = false;
          if (data != null && data.Success && data.Result != null && data.Result) {
            this.sharedFunctions.showMessage("Se guardaron correctamente los datos!", "Operación Exitosa!");
            this.loadView();
          }
          else
            this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error ejecutando la operación", "Error");
        },
          (err: HttpErrorResponse) => {
            this.isBlocking = false;
            this.sharedFunctions.handleError(err, true);
          })
      }
    });
  }

  onReinicioClave() {
    if (this.isProcessing()) return false;

    this.isResetting = true;
    this.usuarioService.resetPassword(this.usuario?.Id ?? 0).subscribe(data => {
      this.isResetting = false;
      if (data != null && data.Success && data.Result != null) {
        this.sharedFunctions.showMessage("Se envió un correo electrónico a la casilla de mail asociado al usuario con las instrucciones para el reinicio de clave", "Reinicio de Clave");
      }
      else
        this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error ejecutando la operación", "Error");
    },
      (err: HttpErrorResponse) => {
        this.isResetting = false;
        this.sharedFunctions.handleError(err, true);
      })
  }

  onCancel() {
    this.location.back();
  }

  cargarImagenVerificacion(fieldName, imageBase64, imageExtension) {
    if (fieldName != null && fieldName.length > 0 && imageBase64 != null && imageBase64.length > 0 && imageExtension != null && imageExtension.length > 0) {

      var index = imageBase64?.toString()?.indexOf(",");
      imageBase64 = (index != null && index >= 0 ? imageBase64?.toString()?.substring(index + 1) : null);

      var r = new SavePersonVerificationImageRequestDto(this.persona.Id ?? 0, fieldName, imageBase64, imageExtension);
      this.isImageLoading = true;

      this.personaService.saveVerificationImagen(r).subscribe(data => {
        this.isImageLoading = false;
        if (data != null && data.Success && data.Result != null) {
          switch (fieldName) {
            case "DniFrente":
              this.persona.FotoDniFrenteUrl = data.Result;
              break;
            case "DniDorso":
              this.persona.FotoDniDorsoUrl = data.Result;
              break;
            case "Selfie":
              this.persona.FotoSelfieUrl = data.Result;
              break;
          }

          this.sharedFunctions.showMessage("Se cargó la imagen exitosamente!", "Imagen cargada");
        }
        else
          this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error ejecutando la operación", "Error");
      },
      (err: HttpErrorResponse) => {
        this.isImageLoading = false;
        this.sharedFunctions.handleError(err, true);
      })
    }
  }

  onTipoDocumentoSelection() {
    var tipoDoc: TipoDocumento | null = null;
    if (this.tipoDocumentoList != null)
      tipoDoc = (this.tipoDocumentoList.filter(f => f.Id == this.personaFormGroup?.get("TipoDocumentoId")?.value))[0];
    this.showCuit = !(tipoDoc?.Nombre?.toUpperCase() == "CUIT" || tipoDoc?.Nombre?.toUpperCase() == "CUIL");
    this.checkPersonaExistance(true, false);
  }

  onNroDocumentoChange() {
    this.checkPersonaExistance(true, false);
  }

  onCuitChange() {
    this.checkPersonaExistance(false, true);
  }

  checkPersonaExistance(searchByDoc: boolean, searchByCuit: boolean) {
    var tipoDocId = this.personaFormGroup?.get("TipoDocumentoId")?.value;
    var nroDoc = this.personaFormGroup?.get("NroDocumento")?.value;
    var cuit = this.personaFormGroup?.get("Cuit")?.value;

    if ((tipoDocId > 0 && nroDoc?.length > 0) || cuit?.length > 0) {
      var r = new SearchPersonaRequestDto(null, null, true, "Apellido", null, null, tipoDocId, nroDoc, null, null, null, true, false);
      if (searchByCuit)
        r = new SearchPersonaRequestDto(null, null, true, "Apellido", null, null, null, null, cuit, null, null, true, false);

      this.isPersonaDataSearching = true;

      this.personaService.search(r).subscribe(data => {
        this.isPersonaDataSearching = false;
        if (data != null && data.result != null && data.result.length > 0) {
          this.personaSearchResult = data?.result[0];

          if (this.personaSearchResult?.Id == this.persona?.Id) {
            this.personaSearchResult = null;
            return;
          }

          var msg = "Se encontró a la persona " + this.personaSearchResult?.Nombre + " " + this.personaSearchResult?.Apellido;
          if (searchByDoc) msg +=" en base al tipo y nro. de documento ingresado. ";
          if (searchByCuit) msg +=" en base al CUIT/CUIL ingresado. ";
          msg += "\n\n¿Desea cargar los datos encontrados?"

          const dialogRef = this.dialog.open(DialogConfirmComponent, {
            data: new DialogConfirmRequest("Persona encontrada", msg, "Sí, carga los datos", "No cargues nada")
          });

          dialogRef.afterClosed().subscribe((result: DialogConfirmResponse) => {
            if (result != null && result.Accepted)
              this.cargarPersonaEncontrada();
            else
              this.noCargarPersonaEncontrada();
          });
        }
      },
      (err: HttpErrorResponse) => {
        this.isPersonaDataSearching = false;
        this.sharedFunctions.handleError(err);
      });
    }
  }

  cargarPersonaEncontrada() {
    if (this.personaSearchResult != null && this.personaSearchResult.Id != null && this.personaSearchResult.Id > 0) {
      if (this.usuario != null)
        this.usuario.PersonaId =this.personaSearchResult.Id;
      this.persona = this.personaSearchResult;
      this.loadPersonData();

      this.personaSearchResult = null;
    }
  }

  noCargarPersonaEncontrada() {
    this.personaSearchResult = null;
  }

  agregarTenantRolRow(tenantId: number | null) {
    var exists = this.tenantRolesList?.some(f => f.TenantId == tenantId);

    if (!exists && (this.tenantRolesList?.length ?? 0) < (this.tenantList?.length ?? 0)) {
      if (this.tenantRolesList == null)
        this.tenantRolesList = [];

      this.tenantRolesList.push({
        TenantId: tenantId,
        RolId: [],
        RolNombre: "",
        Roles: null,
        IsRolSearching: false,
        ConsorcioId: [],
        ConsorcioNombre: "",
        Consorcios: null,
        IsConsorcioSearching: false
      });
    }
  }

  deleteTenantRol(item: any) {
    if (this.tenantRolesList != null && this.tenantRolesList.length > 0) {
      if (this.tenantRolesList[item.index].TenantId != null && this.tenantRolesList[item.index].TenantId > 0) {
        this.tenantRolesList.splice(item.index, 1);
        this.agregarTenantRolRow(null);

        this.tenantRolesGrid?.refresh();
      }
    }
  }

  hasPermissionTenant(rowData: any) {
    return rowData.TenantId == null || (this.tenantList != null && this.tenantList.some(f => f.Id == rowData.TenantId));
  }

  hasPermissionRol(rowData: any) {
    return this.hasPermissionTenant(rowData) &&
            rowData.Roles != null && rowData.Roles.length > 0 &&
            (rowData.RolId == null || rowData.RolId.length == 0 ||
             rowData.Roles.some(f => rowData.RolId.some(x => x == f.Id)));
  }

  hasPermissionConsorcio(rowData: any) {
    return this.hasPermissionTenant(rowData) &&
            rowData.Consorcios != null && rowData.Consorcios.length > 0 &&
            (rowData.ConsorcioId == null || rowData.ConsorcioId.length == 0 ||
             rowData.Consorcios.some(f => rowData.ConsorcioId.some(x => x == f.Id)));
  }

  hasPermissionComunidad(rowData: any) {
    return this.hasPermissionTenant(rowData) &&
            rowData.Comunidades != null && rowData.Comunidades.length > 0 &&
            (rowData.ComunidadId == null || rowData.ComunidadId.length == 0 ||
             rowData.Comunidades.some(f => rowData.ComunidadId.some(x => x == f.Id)));
  }

  hasPermissionComunidadPedidoRol(comunidadId: number) {
    var tenantRowDataList = this.tenantRolesList?.filter(f => f.ComunidadId != null && f.ComunidadId.some(x => x == comunidadId));
    if (tenantRowDataList != null && tenantRowDataList.length > 0)
      return this.hasPermissionComunidad(tenantRowDataList[0]);
    return false;
  }

  viewPersona(id: number) {
    if (id == null || id <= 0) {
      this.sharedFunctions.showMessage("Debe seleccionar un item", "Error");
      return false;
    }

    if (!this.canViewPersonDetail)
      return false;

    this.router.navigate(['persona-edit', id]);
  }
}
